module.exports = __webpack_public_path__ + "img/current.fd9370c.svg";